class ContactUsForm {
  constructor() {
    this.countrySelect = document.getElementById("ContactFormCountry");
    this.provinceSelect = document.getElementById("ContactFormProvince");
    this.provinceWrapper = document.getElementById(
      "ContactFormProvinceWrapper"
    );
    this.submitButton = document.getElementById("submit_button");
    this.form = document.getElementById("contactForm");
    this.statusDiv = document.getElementById("formStatus");
    this.countriesData = [];
    this.defaultKeys = [
      "firstName",
      "lastName",
      "email",
      "phone",
      "country",
      "state",
      "zip",
      "address1",
    ];

    if (this.countrySelect) {
      this.init();
    }
  }

  init() {
    this.fetchCountries();
    this.countrySelect.addEventListener("change", () =>
      this.handleCountryChange()
    );
    if (this.form) {
      this.form.addEventListener("submit", (e) => this.handleSubmit(e));
    }
  }

  async fetchCountries() {
    const endpoint = "https://atlas.shopifysvc.com/graphql";
    const query = `
        query countries($locale: SupportedLocale!) {
          countries(locale: $locale) {
            name
            code
            zones {
              name
              code
            }
          }
        }
      `;

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          operationName: "countries",
          query: query,
          variables: { locale: "EN" },
        }),
      });

      const result = await response.json();
      if (result.errors) throw new Error(result.errors[0].message);

      this.countriesData = result.data.countries;
      this.populateCountrySelect();
    } catch (error) {
      console.error(error);
      this.statusDiv.innerText = "Error loading countries.";
      this.statusDiv.className = "form-status error";
    }
  }

  populateCountrySelect() {
    const defaultCode = this.countrySelect.getAttribute("data-default") || "US";
    this.countrySelect.innerHTML = "";

    this.countriesData.forEach((country) => {
      const option = document.createElement("option");
      option.value = country.code;
      option.text = country.name;
      if (country.code === defaultCode) option.selected = true;
      this.countrySelect.appendChild(option);
    });

    this.handleCountryChange();
  }

  handleCountryChange() {
    const selectedCode = this.countrySelect.value;
    const countryData = this.countriesData.find((c) => c.code === selectedCode);

    this.provinceSelect.innerHTML = "";

    if (countryData && countryData.zones && countryData.zones.length > 0) {
      this.provinceWrapper.style.display = "block";
      this.provinceSelect.setAttribute("required", "required");

      const defaultOption = document.createElement("option");
      defaultOption.text = "Select State";
      defaultOption.value = "";
      defaultOption.disabled = true;
      defaultOption.selected = true;
      this.provinceSelect.appendChild(defaultOption);

      countryData.zones.forEach((zone) => {
        const option = document.createElement("option");
        option.value = zone.code;
        option.text = zone.name;
        this.provinceSelect.appendChild(option);
      });
    } else {
      this.provinceWrapper.style.display = "none";
      this.provinceSelect.removeAttribute("required");
    }
  }

  getFieldLabel(inputName) {
    const inputElement = this.form.querySelector(`[name="${inputName}"]`);
    if (!inputElement) return inputName;

    const id = inputElement.id;
    const labelElement = this.form.querySelector(`label[for="${id}"]`);

    return labelElement.innerText || inputName;
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.submitButton.disabled = true;
    const formData = new FormData(this.form);

    const payload = {
      customer: {},
      description: "",
    };

    let descriptionParts = [];

    for (const [key, value] of formData.entries()) {
      if (!value) {
        continue;
      }
      if (this.defaultKeys.includes(key)) {
        if (key === "state" && this.provinceWrapper.style.display === "none") {
          continue;
        }
        payload.customer[key] = value;
      } else {
        let label = this.getFieldLabel(key);
        label = label.replace(/\?/g, "").trim();

        descriptionParts.push(`${label}: ${value}`);
      }
    }

    payload.description = descriptionParts.join("<br>");
    payload.subject = "Contact Us Form Request";
    payload.requestId = crypto.randomUUID();

    this.statusDiv.innerText = "Sending...";
    this.statusDiv.className = "form-status";

    const submitUrl = this.form.getAttribute("data-submit-url");

    const headers = { "Content-Type": "application/json" };

    try {
      const response = await fetch(submitUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error();

      this.statusDiv.innerText = "Message sent!";
      this.statusDiv.className = "form-status success";
      this.form.reset();
      this.populateCountrySelect();
      this.submitButton.disabled = false;
    } catch (error) {
      this.submitButton.disabled = false;
      console.error(error);
      this.statusDiv.innerText = "Error sending form.";
      this.statusDiv.className = "form-status error";
    }
  }
}

new ContactUsForm();
